import React, { useEffect, useState } from "react";
import Preloader from "../../Shared/Preloader/Preloader";
import Sidebar from "../../Shared/Sidebar";
import LessSidebar from "../../Shared/LessSidebar";
import Navbar from "../../Shared/Navbar/Navbar";
import { useNavigate } from "react-router-dom";
import { currentUser } from "../../../authentication/auth";
import { faCreativeCommons } from "@fortawesome/free-brands-svg-icons";
import { faProjectDiagram, faTasks } from "@fortawesome/free-solid-svg-icons";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import Kanban from "./kanban";
const Organize = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [user, setUser] = useState();

  useEffect(() => {
    if (currentUser() == null) {
      navigate("/login");
    } else {
      setUser(currentUser());
    }
  }, []);
  const onDragEnd = (result) => {};
  const [hideSidebar, setHideSidebar] = useState(
    JSON.parse(localStorage.getItem("sidebar-state"))
  );
  return (
    <>
      <Preloader />
      <div className={`content`}>
        {hideSidebar ? (
          <LessSidebar
            user={user}
            expand={() => {
              setHideSidebar(false);
              localStorage.setItem("sidebar-state", false);
            }}
          />
        ) : (
          <Sidebar
            user={user}
            expand={() => {
              setHideSidebar(true);
              localStorage.setItem("sidebar-state", true);
            }}
          />
        )}
      </div>
      {/* <FirebaseNotif /> */}
      <main className={`content ${hideSidebar ? "mleft-0" : ""}`}>
        <Navbar
          user={user}
          pageName={"Au Labo : Organiser"}
          icon={faProjectDiagram}
        />
        <hr />
        <Kanban />
      </main>
    </>
  );
};

export default Organize;
